var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagnosisItemLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    fill: "#EDDFF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2929 7.29289C14.6834 6.90237 15.3166 6.90237 15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711L12.7071 11.7071C12.3166 12.0976 11.6834 12.0976 11.2929 11.7071C10.9024 11.3166 10.9024 10.6834 11.2929 10.2929L14.2929 7.29289ZM6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929L8.70711 11.2929C9.09763 11.6834 9.09763 12.3166 8.70711 12.7071C8.31658 13.0976 7.68342 13.0976 7.29289 12.7071L6.29289 11.7071C5.90237 11.3166 5.90237 10.6834 6.29289 10.2929ZM10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9ZM10 16C10 16.5523 9.55228 17 9 17C8.44772 17 8 16.5523 8 16C8 15.4477 8.44772 15 9 15C9.55228 15 10 15.4477 10 16ZM18 11.5C18 10.9477 17.5523 10.5 17 10.5C16.4477 10.5 16 10.9477 16 11.5V12C16 12.5523 15.5523 13 15 13C13.3431 13 12 14.3431 12 16V16.5C12 17.0523 12.4477 17.5 13 17.5C13.5523 17.5 14 17.0523 14 16.5V16C14 15.4477 14.4477 15 15 15C16.6569 15 18 13.6569 18 12V11.5Z",
    fill: "#A461D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosisItemLogo);
export default __webpack_public_path__ + "static/media/diagnosis-item-logo.ebc63ffc52fe5bb625745de4c13f744c.svg";
export { ForwardRef as ReactComponent };